import { Outlet } from 'react-router';

export default function Layout() {
  return (
    <main className="mx-auto w-full max-w-screen-md">
      <div className="pr prose mx-auto max-w-none py-10 prose-headings:font-heading-condensed prose-headings:font-medium prose-headings:tracking-tight prose-headings:text-primary-2-80 prose-h1:mb-8 prose-h1:text-center prose-h1:text-5xl prose-h1:leading-10 prose-h2:mb-2 prose-h2:mt-4 prose-h2:text-xl prose-h2:leading-7 prose-h3:text-lg prose-h3:leading-4 prose-p:text-medium prose-p:leading-6 prose-p:text-primary-2-80 prose-a:text-primary-1-80 prose-strong:text-primary-1-80">
        <Outlet />
      </div>
    </main>
  );
}
